import { keyframes } from '@mui/material/styles'

export const fadeSlideIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`

export const drawGauge = keyframes`from { stroke-dashoffset: 251; }`

export const growBar = keyframes`from { transform: scaleY(0); } to { transform: scaleY(1); }`
